import { render, staticRenderFns } from "./editor_property.vue?vue&type=template&id=4cf46a40&scoped=true"
import script from "./editor_property.vue?vue&type=script&lang=js"
export * from "./editor_property.vue?vue&type=script&lang=js"
import style0 from "./editor_property.vue?vue&type=style&index=0&id=4cf46a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf46a40",
  null
  
)

export default component.exports